export default __webpack_public_path__ + "img/93d085a113c8bf4916efa2f3c391f4e5.jpg";